import { SystemLogPayload } from '@signageos/common-types/dist/Device/SystemLogs/systemLogs';
import { SystemLog } from '@signageos/actions/dist/SystemLog/systemLogActions';

export function createSystemLogAction(payload: SystemLogPayload): SystemLog {
	return {
		type: SystemLog,
		payload,
	};
}
